export const API_URL = '/api/v1';
export const AUTH_API_URL = '/auth/api/v1';
export const SERVICE_RESOURCES: string[][] = [
  ['cartoservice', 'wms'],
  ['cartoservice', 'tms'],
  ['data-manager', 'wmsservice'],
  ['data-manager', 'arcgisservice'],
  ['data-manager', 'wmtsservice'],
  ['data-manager', 'geoserverservice']
];
